/*
    Die Sgalinski Typo3-Erweiterung besteht codeseitig aus drei Teilen, die hier zu einer zusammengeführt wurden:
    1) cookieOptinData aus Head; 2) Nachladen des GTM aus essential-0.js; 3) SgCookieOptin aus cookieOptin.js
    Sofern die Sgalinski-Erweiterung selbst aktualisiert wird, ist dieses JS komplett zu überarbeiten.
    Sofern sich nur die Einstellungen ändern, werden Anpassungen an 1) und 2) ausreichen.
*/

/*
    1) Code aus Html-Head für cookieOptinData
    Wurde ursprünglich via '<script id="cookieOptinData" type="application/json"></script>' eingebunden
    Nachträglich gemachte Änderungen:
    - Script in "loadingJavaScript" durch "FunktionGtmLaden" ersetzt. Dies wird
      in 3) ausgewertet und verweist auf die zu 2) eingefügte Funktion gtmLaden().
    - set_cookie_for_domain
*/

const cookieOptinData = {
  cookieGroups: [
    {
      groupName: "essential",
      label: "Notwendig",
      description:
        "Um Ihnen eine sichere und komfortable Nutzung unserer Webseite zu erm\u00f6glichen, ben\u00f6tigen wir den Einsatz dieser Cookies. Dies ist insbesondere f\u00fcr den einwandfreien Ablauf der Sitzung und die Identifizierung eventueller Optimierungspotenziale notwendig. Es werden in diesem Zusammenhang ggf. personenbezogene Daten wie IP erfasst und bearbeitet.",
      required: true,
      cookieData: [],
      scriptData: [
        {
          title: "GTM",
          script:
            "document.TagManagerLoaded = document.TagManagerLoaded || 0;\r\nif (!document.TagManagerLoaded) {\r\n  const gtmId = location.hostname.indexOf('www.')>=0 || location.hostname.indexOf('kunde.')>=0 ? 'GTM-KF2SZ7C' : 'GTM-P88W7H8';\r\n  document.TagManagerLoaded = 1;\r\n  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});const f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer',gtmId);\r\n}",
          html: "",
          index: 0,
        },
      ],
      loadingHTML: "",
      loadingJavaScript: "FunktionGtmLaden",
    },
    {
      groupName: "statistik",
      label: "Statistik",
      description:
        "Unser Angebot und unsere Website verbessern wir stetig f\u00fcr Sie. Aus diesem Hintergrund sammeln wir Daten f\u00fcr Analyse- und Statistikzwecke. Mithilfe dieser Cookies k\u00f6nnen wir unsere Inhalte f\u00fcr Sie optimieren. F\u00fcr diesen Zweck werden die Daten aus Ihrer Sitzung mit Google Analytics verarbeitet. In diesem Zusammenhang k\u00f6nnen Ihre Daten von Google zur Profilbildung oder ggf. zur Verkn\u00fcpfung mit einem Google-Account verwendet werden.",
      required: false,
      cookieData: [],
      scriptData: [],
      loadingHTML: "",
      loadingJavaScript: "",
    },
    {
      groupName: "marketing",
      label: "Marketing",
      description:
        "Um Ihnen Inhalte anzeigen zu k\u00f6nnen, die Sie interessieren oder die f\u00fcr Sie relevant sind, ben\u00f6tigen wir diese Cookies. Dar\u00fcber hinaus erm\u00f6glichen uns diese Cookies, den Erfolg unserer Marketingma\u00dfnahmen zu messen. F\u00fcr diesen Zweck werden die Daten aus Ihrer Sitzung mit Google Analytics und Facebook Pixel verarbeitet. In diesem Zusammenhang k\u00f6nnen Ihre Daten von Google und Facebook zur Profilbildung oder ggf. zur Verkn\u00fcpfung mit einem Google- oder Facebook-Account verwendet werden.",
      required: false,
      cookieData: [],
      scriptData: [],
      loadingHTML: "",
      loadingJavaScript: "",
    },
  ],
  cssData: {
    color_box: "#FFFFFF",
    color_headline: "#373737",
    color_text: "#373737",
    color_confirmation_background: "#C9FFC9",
    color_confirmation_text: "#208A20",
    color_checkbox: "#0f5582",
    color_checkbox_required: "#A5A5A5",
    color_button_all: "#0f5582",
    color_button_all_hover: "#2375aa",
    color_button_all_text: "#FFFFFF",
    color_button_specific: "#A5A5A5",
    color_button_specific_hover: "#D7D7D7",
    color_button_specific_text: "#FFFFFF",
    color_button_essential: "#d9d9d9",
    color_button_essential_hover: "#D7D7D7",
    color_button_essential_text: "#FFFFFF",
    color_button_close: "#FFFFFF",
    color_button_close_hover: "#FFFFFF",
    color_button_close_text: "#373737",
    color_list: "#A5A5A5",
    color_list_text: "#FFFFFF",
    color_table: "#FFFFFF",
    color_Table_data_text: "#373737",
    color_table_header: "#F3F3F3",
    color_table_header_text: "#373737",
    color_full_box: "#0f5582",
    color_full_headline: "#FFFFFF",
    color_full_text: "#FFFFFF",
    color_full_button_close: "#143D59",
    color_full_button_close_hover: "#143D59",
    color_full_button_close_text: "#FFFFFF",
    iframe_color_consent_box_background: "#D6D6D6",
    iframe_color_button_load_one: "#143D59",
    iframe_color_button_load_one_hover: "#2E6B96",
    iframe_color_button_load_one_text: "#FFFFFF",
    iframe_color_open_settings: "#373737",
    banner_color_box: "#DDDDDD",
    banner_color_text: "#373737",
    banner_color_link_text: "#373737",
    banner_color_button_settings: "#A5A5A5",
    banner_color_button_settings_hover: "#D7D7D7",
    banner_color_button_settings_text: "#FFFFFF",
    banner_color_button_accept: "#143D59",
    banner_color_button_accept_hover: "#2E6B96",
    banner_color_button_accept_text: "#FFFFFF",
  },
  footerLinks: [
    {
      url: "https://www.gev-versicherung.de/?id=datenschutz&disableOptIn=1&L=0",
      name: "Datenschutz",
      uid: 302,
      index: 0,
    },
    {
      url: "https://www.gev-versicherung.de/?id=impressum&disableOptIn=1&L=0",
      name: "Impressum",
      uid: 303,
      index: 1,
    },
  ],
  iFrameGroup: {
    groupName: "iframes",
    label: "Externe Inhalte",
    description:
      "Wir verwenden auf unserer Website externe Inhalte, um Ihnen zus\u00e4tzliche Informationen anzubieten.",
    required: false,
    cookieData: [],
  },
  settings: {
    banner_enable: false,
    banner_position: 1,
    banner_show_settings_button: true,
    cookie_lifetime: 365,
    session_only_essential_cookies: false,
    iframe_enabled: false,
    minify_generated_data: true,
    show_button_close: false,
    activate_testing_mode: false,
    disable_powered_by: true,
    set_cookie_for_domain:
      location.hostname.indexOf("gev-versicherung") >= 0
        ? "gev-versicherung.de"
        : "",
  },
  textEntries: {
    header: "Mehr Datenschutz f\u00fcr Ihre Privatsph\u00e4re",
    description:
      "Wir nutzen Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Dazu z\u00e4hlen Cookies, die f\u00fcr den Betrieb der Seite notwendig sind, sowie solche, die zu anonymen Statistikzwecken oder zur Anzeige personalisierter Inhalte genutzt werden. Sie k\u00f6nnen selbst entscheiden, welche Kategorien Sie zulassen m\u00f6chten. Bitte beachten Sie, dass auf Basis Ihrer Einstellungen wom\u00f6glich nicht mehr alle Funktionalit\u00e4ten der Seite zur Verf\u00fcgung stehen.",
    accept_all_text: "Alle best\u00e4tigen",
    accept_specific_text: "Auswahl \u00fcbernehmen",
    accept_essential_text: "Nur notwendige Cookies akzeptieren",
    extend_box_link_text: "Weitere Informationen anzeigen",
    extend_box_link_text_close: "Weitere Informationen verstecken",
    extend_table_link_text: "Cookie-Informationen anzeigen",
    extend_table_link_text_close: "Cookie-Informationen verstecken",
    cookie_name_text: "Name",
    cookie_provider_text: "Anbieter",
    cookie_purpose_text: "Zweck",
    cookie_lifetime_text: "Laufzeit",
    iframe_button_allow_all_text: "Alle externen Inhalte erlauben",
    iframe_button_allow_one_text: "Einmalig erlauben",
    iframe_button_load_one_text: "Externen Inhalt laden",
    iframe_open_settings_text: "Einstellungen anzeigen",
    banner_button_accept_text: "Akzeptieren",
    banner_button_settings_text: "Einstellungen",
    banner_description:
      "Auf unserer Webseite werden Cookies verwendet. Einige davon werden zwingend ben\u00f6tigt, w\u00e4hrend es uns andere erm\u00f6glichen, Ihre Nutzererfahrung auf unserer Webseite zu verbessern.",
    save_confirmation_text: "Cookie-Einstellungen erfolgreich gespeichert",
  },
  mustacheData: {
    template: {
      template_html:
        '<!--googleoff: index-->\n<div class="sg-cookie-optin-box">\n\t{{#settings.show_button_close}}\n\t\t<span class="sg-cookie-optin-box-close-button">\u2715</span>\n\t{{/settings.show_button_close}}\n\n\t<strong class="sg-cookie-optin-box-header">{{{textEntries.header}}}</strong>\n\t<p class="sg-cookie-optin-box-description">{{{textEntries.description}}}</p>\n\n\t<ul class="sg-cookie-optin-box-cookie-list">\n\t\t{{#cookieGroups}}\n\t\t\t<li class="sg-cookie-optin-box-cookie-list-item">\n\t\t\t\t<label >\n\t\t\t\t\t<input class="sg-cookie-optin-checkbox"\n\t\t\t\t\t   type="checkbox"\n\t\t\t\t\t   name="cookies[]"\n\t\t\t\t\t   value="{{groupName}}"\n\t\t\t\t\t   {{#required}}checked="1"{{/required}}\n\t\t\t\t\t   {{#required}}disabled="1"{{/required}}>\n\t\t\t\t\t<span class="sg-cookie-optin-checkbox-label">{{{label}}}</span>\n\t\t\t\t</label>\n\t\t\t</li>\n\t\t{{/cookieGroups}}\n\t</ul>\n\n\t<div class="sg-cookie-optin-box-button">\n\t\t<button class="sg-cookie-optin-box-button-accept-all">{{{textEntries.accept_all_text}}}</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-specific">{{{textEntries.accept_specific_text}}}</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-essential">{{{textEntries.accept_essential_text}}}</button>\n\t</div>\n\n\t<ul class="sg-cookie-optin-box-cookie-detail-list">\n\t\t{{#cookieGroups}}\n\t\t\t<li class="sg-cookie-optin-box-cookie-detail-list-item">\n\t\t\t\t<strong class="sg-cookie-optin-box-cookie-detail-header">{{{label}}}</strong>\n\t\t\t\t<p class="sg-cookie-optin-box-cookie-detail-description">{{{description}}}</p>\n\n\t\t\t\t<div class="sg-cookie-optin-box-cookie-detail-sublist">\n\t\t\t\t\t<table>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t{{#cookieData}}\n\t\t\t\t\t\t\t\t{{^pseudo}}\n\t\t\t\t\t\t\t\t\t{{#index}}<tr class="divider"><td colspan="2">&nbsp;</td></tr>{{/index}}\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th>{{{textEntries.cookie_name_text}}}</th>\n\t\t\t\t\t\t\t\t\t\t<td>{{{Name}}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th>{{{textEntries.cookie_provider_text}}}</th>\n\t\t\t\t\t\t\t\t\t\t<td>{{{Provider}}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th>{{{textEntries.cookie_lifetime_text}}}</th>\n\t\t\t\t\t\t\t\t\t\t<td>{{{Lifetime}}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th>{{{textEntries.cookie_purpose_text}}}</th>\n\t\t\t\t\t\t\t\t\t\t<td class="sg-cookie-optin-box-table-reason">{{{Purpose}}}</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t{{/pseudo}}\n\t\t\t\t\t\t\t{{/cookieData}}\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</div>\n\n\t\t\t\t{{#cookieData}}\n\t\t\t\t\t{{^index}}<a class="sg-cookie-optin-box-sublist-open-more-link" href="#">{{{textEntries.extend_table_link_text}}}</a>{{/index}}\n\t\t\t\t{{/cookieData}}\n\t\t\t</li>\n\t\t{{/cookieGroups}}\n\t</ul>\n\n\t<div class="sg-cookie-optin-box-open-more">\n\t\t<a class="sg-cookie-optin-box-open-more-link" href="#">{{{textEntries.extend_box_link_text}}}</a>\n\t</div>\n\n\t<div class="sg-cookie-optin-box-footer">\n\t\t<div class="sg-cookie-optin-box-copyright">\n\t\t\t<a class="sg-cookie-optin-box-copyright-link{{#settings.disable_powered_by}} sg-cookie-optin-box-copyright-link-hidden{{/settings.disable_powered_by}}"\n\t\t\t   href="https://www.sgalinski.de/typo3-produkte-webentwicklung/sgalinski-cookie-optin/"\n\t\t\t   target="_blank">\n\t\t\t\tPowered by<br>sgalinski Cookie Opt In\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="sg-cookie-optin-box-footer-links">\n\t\t\t{{#footerLinks}}\n\t\t\t\t{{#index}}\n\t\t\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\t\t\t\t{{/index}}\n\n\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="{{url}}" target="_blank">{{{name}}}</a>\n\t\t\t{{/footerLinks}}\n\t\t</div>\n\t</div>\n</div>\n<!--googleon: index-->\n',
      template_overwritten: 0,
      template_selection: 0,
      markup:
        '<!--googleoff: index-->\n<div class="sg-cookie-optin-box">\n\n\t<strong class="sg-cookie-optin-box-header">Mehr Datenschutz f\u00fcr Ihre Privatsph\u00e4re</strong>\n\t<p class="sg-cookie-optin-box-description">Wir nutzen Cookies, um Ihnen ein optimales Webseiten-Erlebnis zu bieten. Dazu z\u00e4hlen Cookies, die f\u00fcr den Betrieb der Seite notwendig sind, sowie solche, die zu anonymen Statistikzwecken oder zur Anzeige personalisierter Inhalte genutzt werden. Sie k\u00f6nnen selbst entscheiden, welche Kategorien Sie zulassen m\u00f6chten. Bitte beachten Sie, dass auf Basis Ihrer Einstellungen wom\u00f6glich nicht mehr alle Funktionalit\u00e4ten der Seite zur Verf\u00fcgung stehen.</p>\n\n\t<ul class="sg-cookie-optin-box-cookie-list">\n\t\t\t<li class="sg-cookie-optin-box-cookie-list-item">\n\t\t\t\t<label >\n\t\t\t\t\t<input class="sg-cookie-optin-checkbox"\n\t\t\t\t\t   type="checkbox"\n\t\t\t\t\t   name="cookies[]"\n\t\t\t\t\t   value="essential"\n\t\t\t\t\t   checked="1"\n\t\t\t\t\t   disabled="1">\n\t\t\t\t\t<span class="sg-cookie-optin-checkbox-label">Notwendig</span>\n\t\t\t\t</label>\n\t\t\t</li>\n\t\t\t<li class="sg-cookie-optin-box-cookie-list-item">\n\t\t\t\t<label >\n\t\t\t\t\t<input class="sg-cookie-optin-checkbox"\n\t\t\t\t\t   type="checkbox"\n\t\t\t\t\t   name="cookies[]"\n\t\t\t\t\t   value="statistik"\n\t\t\t\t\t   \n\t\t\t\t\t   >\n\t\t\t\t\t<span class="sg-cookie-optin-checkbox-label">Statistik</span>\n\t\t\t\t</label>\n\t\t\t</li>\n\t\t\t<li class="sg-cookie-optin-box-cookie-list-item">\n\t\t\t\t<label >\n\t\t\t\t\t<input class="sg-cookie-optin-checkbox"\n\t\t\t\t\t   type="checkbox"\n\t\t\t\t\t   name="cookies[]"\n\t\t\t\t\t   value="marketing"\n\t\t\t\t\t   \n\t\t\t\t\t   >\n\t\t\t\t\t<span class="sg-cookie-optin-checkbox-label">Marketing</span>\n\t\t\t\t</label>\n\t\t\t</li>\n\t</ul>\n\n\t<div class="sg-cookie-optin-box-button">\n\t\t<button class="sg-cookie-optin-box-button-accept-all">Alle best\u00e4tigen</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-specific">Auswahl \u00fcbernehmen</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-essential">Nur notwendige Cookies akzeptieren</button>\n\t</div>\n\n\t<ul class="sg-cookie-optin-box-cookie-detail-list">\n\t\t\t<li class="sg-cookie-optin-box-cookie-detail-list-item">\n\t\t\t\t<strong class="sg-cookie-optin-box-cookie-detail-header">Notwendig</strong>\n\t\t\t\t<p class="sg-cookie-optin-box-cookie-detail-description">Um Ihnen eine sichere und komfortable Nutzung unserer Webseite zu erm\u00f6glichen, ben\u00f6tigen wir den Einsatz dieser Cookies. Dies ist insbesondere f\u00fcr den einwandfreien Ablauf der Sitzung und die Identifizierung eventueller Optimierungspotenziale notwendig. Es werden in diesem Zusammenhang ggf. personenbezogene Daten wie IP erfasst und bearbeitet.</p>\n\n\t\t\t\t<div class="sg-cookie-optin-box-cookie-detail-sublist">\n\t\t\t\t\t<table>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</div>\n\n\t\t\t</li>\n\t\t\t<li class="sg-cookie-optin-box-cookie-detail-list-item">\n\t\t\t\t<strong class="sg-cookie-optin-box-cookie-detail-header">Statistik</strong>\n\t\t\t\t<p class="sg-cookie-optin-box-cookie-detail-description">Unser Angebot und unsere Website verbessern wir stetig f\u00fcr Sie. Aus diesem Hintergrund sammeln wir Daten f\u00fcr Analyse- und Statistikzwecke. Mithilfe dieser Cookies k\u00f6nnen wir unsere Inhalte f\u00fcr Sie optimieren. F\u00fcr diesen Zweck werden die Daten aus Ihrer Sitzung mit Google Analytics verarbeitet. In diesem Zusammenhang k\u00f6nnen Ihre Daten von Google zur Profilbildung oder ggf. zur Verkn\u00fcpfung mit einem Google-Account verwendet werden.</p>\n\n\t\t\t\t<div class="sg-cookie-optin-box-cookie-detail-sublist">\n\t\t\t\t\t<table>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</div>\n\n\t\t\t</li>\n\t\t\t<li class="sg-cookie-optin-box-cookie-detail-list-item">\n\t\t\t\t<strong class="sg-cookie-optin-box-cookie-detail-header">Marketing</strong>\n\t\t\t\t<p class="sg-cookie-optin-box-cookie-detail-description">Um Ihnen Inhalte anzeigen zu k\u00f6nnen, die Sie interessieren oder die f\u00fcr Sie relevant sind, ben\u00f6tigen wir diese Cookies. Dar\u00fcber hinaus erm\u00f6glichen uns diese Cookies, den Erfolg unserer Marketingma\u00dfnahmen zu messen. F\u00fcr diesen Zweck werden die Daten aus Ihrer Sitzung mit Google Analytics und Facebook Pixel verarbeitet. In diesem Zusammenhang k\u00f6nnen Ihre Daten von Google und Facebook zur Profilbildung oder ggf. zur Verkn\u00fcpfung mit einem Google- oder Facebook-Account verwendet werden.</p>\n\n\t\t\t\t<div class="sg-cookie-optin-box-cookie-detail-sublist">\n\t\t\t\t\t<table>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</div>\n\n\t\t\t</li>\n\t</ul>\n\n\t<div class="sg-cookie-optin-box-open-more">\n\t\t<a class="sg-cookie-optin-box-open-more-link" href="#">Weitere Informationen anzeigen</a>\n\t</div>\n\n\t<div class="sg-cookie-optin-box-footer">\n\t\t<div class="sg-cookie-optin-box-copyright">\n\t\t\t<a class="sg-cookie-optin-box-copyright-link sg-cookie-optin-box-copyright-link-hidden"\n\t\t\t   href="https://www.sgalinski.de/typo3-produkte-webentwicklung/sgalinski-cookie-optin/"\n\t\t\t   target="_blank">\n\t\t\t\tPowered by<br>sgalinski Cookie Opt In\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="sg-cookie-optin-box-footer-links">\n\n\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=datenschutz&amp;disableOptIn=1&amp;L=0" target="_blank">Datenschutz</a>\n\t\t\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\n\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=impressum&amp;disableOptIn=1&amp;L=0" target="_blank">Impressum</a>\n\t\t</div>\n\t</div>\n</div>\n<!--googleon: index-->\n',
    },
    banner: {
      banner_html:
        '<div class="sg-cookie-optin-banner {{^settings.banner_position}}sg-cookie-optin-banner-bottom{{/settings.banner_position}}">\n\t<div class="sg-cookie-optin-box">\n\t\t<div class="sg-cookie-optin-banner-content">\n\t\t\t<p class="sg-cookie-optin-banner-description">\n\t\t\t\t{{{textEntries.banner_description}}}\n\n\t\t\t\t{{#footerLinks}}\n\t\t\t\t\t{{#index}}\n\t\t\t\t\t\t(\n\t\t\t\t\t{{/index}}\n\t\t\t\t{{/footerLinks}}\n\n\t\t\t\t{{#footerLinks}}\n\t\t\t\t\t{{#index}}\n\t\t\t\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\t\t\t\t\t{{/index}}\n\n\t\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="{{url}}" target="_blank">{{{name}}}</a>\n\t\t\t\t{{/footerLinks}}\n\n\t\t\t\t{{#footerLinks}}\n\t\t\t\t\t{{#index}}\n\t\t\t\t\t\t)\n\t\t\t\t\t{{/index}}\n\t\t\t\t{{/footerLinks}}\n\t\t\t</p>\n\n\t\t\t<div class="sg-cookie-optin-banner-button">\n\t\t\t\t{{#settings.banner_show_settings_button}}\n\t\t\t\t\t<button class="sg-cookie-optin-banner-button-settings">{{{textEntries.banner_button_settings_text}}}</button>\n\t\t\t\t{{/settings.banner_show_settings_button}}\n\n\t\t\t\t<button class="sg-cookie-optin-banner-button-accept">{{{textEntries.banner_button_accept_text}}}</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
      banner_overwritten: 0,
      banner_selection: 0,
      markup:
        '<div class="sg-cookie-optin-banner ">\n\t<div class="sg-cookie-optin-box">\n\t\t<div class="sg-cookie-optin-banner-content">\n\t\t\t<p class="sg-cookie-optin-banner-description">\n\t\t\t\tAuf unserer Webseite werden Cookies verwendet. Einige davon werden zwingend ben\u00f6tigt, w\u00e4hrend es uns andere erm\u00f6glichen, Ihre Nutzererfahrung auf unserer Webseite zu verbessern.\n\n\t\t\t\t\t\t(\n\n\n\t\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=datenschutz&amp;disableOptIn=1&amp;L=0" target="_blank">Datenschutz</a>\n\t\t\t\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\n\t\t\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=impressum&amp;disableOptIn=1&amp;L=0" target="_blank">Impressum</a>\n\n\t\t\t\t\t\t)\n\t\t\t</p>\n\n\t\t\t<div class="sg-cookie-optin-banner-button">\n\t\t\t\t\t<button class="sg-cookie-optin-banner-button-settings">Einstellungen</button>\n\n\t\t\t\t<button class="sg-cookie-optin-banner-button-accept">Akzeptieren</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n',
    },
    iframe: {
      iframe_html:
        '<div class="sg-cookie-optin-box">\n\t{{#settings.show_button_close}}\n\t\t<span class="sg-cookie-optin-box-close-button">\u2715</span>\n\t{{/settings.show_button_close}}\n\n\t<strong class="sg-cookie-optin-box-header">{{{iFrameGroup.label}}}</strong>\n\t<p class="sg-cookie-optin-box-description">{{{iFrameGroup.description}}}</p>\n\n\t<div class="sg-cookie-optin-box-button">\n\t\t<button class="sg-cookie-optin-box-button-accept-all">{{{textEntries.iframe_button_allow_all_text}}}</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-specific">{{{textEntries.iframe_button_allow_one_text}}}</button>\n\t</div>\n\n\t<p class="sg-cookie-optin-box-flash-message"></p>\n\n\t<div class="sg-cookie-optin-box-footer">\n\t\t<div class="sg-cookie-optin-box-copyright">\n\t\t\t<a class="sg-cookie-optin-box-copyright-link"\n\t\t\t   href="https://www.sgalinski.de/typo3-produkte-webentwicklung/sgalinski-cookie-optin/"\n\t\t\t   target="_blank">\n\t\t\t\tPowered by<br>sgalinski Cookie Opt In\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="sg-cookie-optin-box-footer-links">\n\t\t\t{{#footerLinks}}\n\t\t\t{{#index}}\n\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\t\t\t{{/index}}\n\t\t\t<a class="sg-cookie-optin-box-footer-link" href="{{url}}" target="_blank">{{{name}}}</a>\n\t\t\t{{/footerLinks}}\n\t\t</div>\n\t</div>\n</div>\n',
      iframe_overwritten: 0,
      iframe_selection: 0,
      markup:
        '<div class="sg-cookie-optin-box">\n\n\t<strong class="sg-cookie-optin-box-header">Externe Inhalte</strong>\n\t<p class="sg-cookie-optin-box-description">Wir verwenden auf unserer Website externe Inhalte, um Ihnen zus\u00e4tzliche Informationen anzubieten.</p>\n\n\t<div class="sg-cookie-optin-box-button">\n\t\t<button class="sg-cookie-optin-box-button-accept-all">Alle externen Inhalte erlauben</button>\n\t\t<button class="sg-cookie-optin-box-button-accept-specific">Einmalig erlauben</button>\n\t</div>\n\n\t<p class="sg-cookie-optin-box-flash-message"></p>\n\n\t<div class="sg-cookie-optin-box-footer">\n\t\t<div class="sg-cookie-optin-box-copyright">\n\t\t\t<a class="sg-cookie-optin-box-copyright-link"\n\t\t\t   href="https://www.sgalinski.de/typo3-produkte-webentwicklung/sgalinski-cookie-optin/"\n\t\t\t   target="_blank">\n\t\t\t\tPowered by<br>sgalinski Cookie Opt In\n\t\t\t</a>\n\t\t</div>\n\n\t\t<div class="sg-cookie-optin-box-footer-links">\n\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=datenschutz&amp;disableOptIn=1&amp;L=0" target="_blank">Datenschutz</a>\n\t\t\t<span class="sg-cookie-optin-box-footer-divider"> | </span>\n\t\t\t<a class="sg-cookie-optin-box-footer-link" href="https://www.gev-versicherung.de/?id=impressum&amp;disableOptIn=1&amp;L=0" target="_blank">Impressum</a>\n\t\t</div>\n\t</div>\n</div>\n',
    },
    iframeReplacement: {
      iframe_replacement_html:
        '<button class="sg-cookie-optin-iframe-consent-accept">{{{textEntries.iframe_button_load_one_text}}}</button>\n<a class="sg-cookie-optin-iframe-consent-link">{{{textEntries.iframe_open_settings_text}}}</a>\n',
      iframe_replacement_overwritten: 0,
      iframe_replacement_selection: 0,
      markup:
        '<button class="sg-cookie-optin-iframe-consent-accept">Externen Inhalt laden</button>\n<a class="sg-cookie-optin-iframe-consent-link">Einstellungen anzeigen</a>\n',
    },
    iframeWhitelist: {
      iframe_whitelist_regex:
        "^https:\\/\\/www\\.google\\.com\\/recaptcha\\/\n",
      iframe_whitelist_overwritten: 0,
      iframe_whitelist_selection: 0,
      markup: "^https:\\/\\/www\\.google\\.com\\/recaptcha\\/\n",
    },
  },
};

/*
    2) Code aus essential-0.js wird hier als Funktion zur Verfügung gestellt.
*/
function gtmLaden() {
  document.TagManagerLoaded = document.TagManagerLoaded || 0;
  if (!document.TagManagerLoaded) {
    const gtmId =
      location.hostname.indexOf("www.") >= 0 ||
      location.hostname.indexOf("service.") >= 0
        ? "GTM-KF2SZ7C"
        : "GTM-P88W7H8";
    document.TagManagerLoaded = 1;
    (function (a, n, d, e, g) {
      a[e] = a[e] || [];
      a[e].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const o = n.getElementsByTagName(d)[0],
        t = n.createElement(d),
        m = e != "dataLayer" ? "&l=" + e : "";
      t.async = !0;
      t.src = "https://www.googletagmanager.com/gtm.js?id=" + g + m;
      o.parentNode.insertBefore(t, o);
    })(window, document, "script", "dataLayer", gtmId);
  }
}

/*
    3) Code aus cookieOptin.js.  Anpassungen:
    - SgCookieOptin.jsonData wird durch Variable aus 1) belegt.
    - Auswertung von "loadingJavaScript": Einbau einer Weiche auf gtmLaden() aus 2),
      sofern Inhalt  = "FunktionGtmLaden".
*/
const SgCookieOptin = {
  COOKIE_NAME: "cookie_optin",
  COOKIE_GROUP_EXTERNAL_CONTENT: "iframes",
  COOKIE_GROUP_ESSENTIAL: "essential",
  EXTERNAL_CONTENT_ELEMENT_SELECTOR:
    "iframe, object, video, audio, [data-external-content-protection], .frame-external-content-protection",
  EXTERNAL_CONTENT_ALLOWED_ELEMENT_SELECTOR:
    "[data-external-content-no-protection], [data-iframe-allow-always], .frame-external-content-no-protection",
  externalContentObserver: null,
  protectedExternalContents: [],
  lastOpenedExternalContentId: 0,
  jsonData: {},
  run: function () {
    SgCookieOptin.closestPolyfill();
    /* SgCookieOptin.jsonData aus cookieOptinData übernehmen - nicht mehr aus CodeBlock im Header */
    SgCookieOptin.jsonData = cookieOptinData;
    /*
        SgCookieOptin.jsonData = JSON.parse(
          document.getElementById("cookieOptinData").innerHTML
        );
         */
    if (SgCookieOptin.jsonData) {
      document.addEventListener("DOMContentLoaded", function () {
        SgCookieOptin.initialize();
      });
      SgCookieOptin.checkForExternalContents();
    }
  },
  initialize: function () {
    SgCookieOptin.handleScriptActivations();
    const i = document.querySelectorAll(
      ".sg-cookie-optin-plugin-uninitialized",
    );
    for (let t = 0; t < i.length; ++t) {
      const e = i[t];
      SgCookieOptin.openCookieOptin(e, { hideBanner: !0 });
      e.classList.remove("sg-cookie-optin-plugin-uninitialized");
      e.classList.add("sg-cookie-optin-plugin-initialized");
    }
    const r = SgCookieOptin.getParameterByName("disableOptIn") == !0;
    if (r) {
      return;
    }
    const o = SgCookieOptin.getParameterByName("showOptIn") == !0,
      n = SgCookieOptin.getCookie(SgCookieOptin.COOKIE_NAME);
    if ((!n && !SgCookieOptin.jsonData.settings.activate_testing_mode) || o) {
      SgCookieOptin.openCookieOptin(null, { hideBanner: !1 });
    }
  },
  handleScriptActivations: function () {
    const s = SgCookieOptin.getCookie(SgCookieOptin.COOKIE_NAME);
    if (!s) {
      return;
    }
    const n = s.split("|");
    for (const a in n) {
      if (!n.hasOwnProperty(a)) {
        continue;
      }
      const l = n[a],
        t = l.split(":");
      if (!t.hasOwnProperty(0) || !t.hasOwnProperty(1)) {
        continue;
      }
      const c = t[0],
        p = parseInt(t[1]);
      if (!p) {
        continue;
      }
      for (const e in SgCookieOptin.jsonData.cookieGroups) {
        if (
          !SgCookieOptin.jsonData.cookieGroups.hasOwnProperty(e) ||
          SgCookieOptin.jsonData.cookieGroups[e].groupName !== c
        ) {
          continue;
        }
        if (
          SgCookieOptin.jsonData.cookieGroups[e].loadingHTML &&
          SgCookieOptin.jsonData.cookieGroups[e].loadingHTML !== ""
        ) {
          const o = document.getElementsByTagName("head")[0];
          if (o) {
            const r = document.createRange();
            r.selectNode(o);
            o.appendChild(
              r.createContextualFragment(
                SgCookieOptin.jsonData.cookieGroups[e].loadingHTML,
              ),
            );
          }
        }
        if (
          SgCookieOptin.jsonData.cookieGroups[e].loadingJavaScript &&
          SgCookieOptin.jsonData.cookieGroups[e].loadingJavaScript !== ""
        ) {
          if (
            SgCookieOptin.jsonData.cookieGroups[e].loadingJavaScript ===
            "FunktionGtmLaden"
          ) {
            gtmLaden();
          } else {
            const i = document.createElement("script");
            i.setAttribute(
              "src",
              SgCookieOptin.jsonData.cookieGroups[e].loadingJavaScript,
            );
            i.setAttribute("type", "text/javascript");
            document.body.appendChild(i);
          }
        }
      }
    }
  },
  openCookieOptin: function (e, t) {
    let o = typeof t == "object" && t.hideBanner === !0,
      i = document.createElement("DIV");
    i.id = "SgCookieOptin";
    if (!e && SgCookieOptin.jsonData.settings.banner_enable && !o) {
      i.classList.add("sg-cookie-optin-banner-wrapper");
      i.insertAdjacentHTML(
        "afterbegin",
        SgCookieOptin.jsonData.mustacheData.banner.markup,
      );
    } else {
      i.insertAdjacentHTML(
        "afterbegin",
        SgCookieOptin.jsonData.mustacheData.template.markup,
      );
    }
    SgCookieOptin.addListeners(i, e);
    if (!e) {
      document.body.insertAdjacentElement("beforeend", i);
    } else {
      e.appendChild(i);
    }
    setTimeout(function () {
      SgCookieOptin.adjustDescriptionHeight(i, e);
      SgCookieOptin.updateCookieList();
    }, 10);
  },
  adjustDescriptionHeight: function (e, t) {
    let n = 4;
    if (t === null) {
      if (window.innerWidth <= 750) {
        return;
      } else if (window.innerWidth <= 1050) {
        n = 2;
      } else if (window.innerWidth <= 1250) {
        n = 3;
      }
    } else {
      n = 2;
    }
    let r = [],
      o = 0,
      a = e.querySelectorAll(
        ".sg-cookie-optin-box-new .sg-cookie-optin-checkbox-description",
      );
    for (let i = 0; i < a.length; ++i) {
      if (!(i % n)) {
        ++o;
      }
      const s = a[i].getBoundingClientRect().height,
        c = r[o] ? r[o] : 0;
      if (s > c) {
        r[o] = s;
      }
    }
    o = 0;
    for (let i = 0; i < a.length; ++i) {
      if (!(i % n)) {
        ++o;
      }
      a[i].style.height = r[o] + "px";
    }
  },
  adjustReasonHeight: function (e, t) {
    let s = 3;
    if (t === null) {
      if (window.innerWidth <= 750) {
        return;
      } else if (window.innerWidth <= 1050) {
        s = 2;
      }
    } else {
      s = 2;
    }
    const p = e.querySelectorAll(
      ".sg-cookie-optin-box-new .sg-cookie-optin-box-cookie-list-item",
    );
    for (let c = 0; c < p.length; ++c) {
      let a = [],
        o = 0,
        n = p[c].querySelectorAll(".sg-cookie-optin-box-table-reason");
      for (let i = 0; i < n.length; ++i) {
        if (!(i % s)) {
          ++o;
        }
        let r = n[i].getBoundingClientRect().height;
        r -= parseInt(
          window.getComputedStyle(n[i], null).getPropertyValue("padding-top"),
        );
        r -= parseInt(
          window
            .getComputedStyle(n[i], null)
            .getPropertyValue("padding-bottom"),
        );
        const l = a[o] ? a[o] : 0;
        if (r > l) {
          a[o] = r;
        }
      }
      o = 0;
      for (let i = 0; i < n.length; ++i) {
        if (!(i % s)) {
          ++o;
        }
        n[i].style.height = a[o] + "px";
      }
    }
  },
  addListeners: function (e, t) {
    const c = e.querySelectorAll(".sg-cookie-optin-box-close-button");
    SgCookieOptin.addEventListenerToList(c, "click", function () {
      SgCookieOptin.acceptEssentialCookies();
      SgCookieOptin.updateCookieList();
      SgCookieOptin.handleScriptActivations();
      if (!t) {
        SgCookieOptin.hideCookieOptIn();
      }
    });
    const s = e.querySelectorAll(".sg-cookie-optin-box-open-more-link");
    SgCookieOptin.addEventListenerToList(
      s,
      "click",
      SgCookieOptin.openCookieDetails,
    );
    const a = e.querySelectorAll(".sg-cookie-optin-box-sublist-open-more-link");
    SgCookieOptin.addEventListenerToList(a, "click", function (e) {
      SgCookieOptin.openSubList(e, t);
    });
    const r = e.querySelectorAll(
      ".sg-cookie-optin-box-button-accept-all, .sg-cookie-optin-banner-button-accept",
    );
    SgCookieOptin.addEventListenerToList(r, "click", function () {
      SgCookieOptin.acceptAllCookies();
      SgCookieOptin.updateCookieList();
      SgCookieOptin.handleScriptActivations();
      if (!t) {
        SgCookieOptin.hideCookieOptIn();
      } else {
        SgCookieOptin.showSaveConfirmation(t);
      }
    });
    const n = e.querySelectorAll(".sg-cookie-optin-box-button-accept-specific");
    SgCookieOptin.addEventListenerToList(n, "click", function () {
      SgCookieOptin.acceptSpecificCookies(this);
      SgCookieOptin.updateCookieList(this);
      SgCookieOptin.handleScriptActivations();
      if (!t) {
        SgCookieOptin.hideCookieOptIn();
      } else {
        SgCookieOptin.showSaveConfirmation(t);
      }
    });
    const o = e.querySelectorAll(
      ".sg-cookie-optin-box-button-accept-essential",
    );
    SgCookieOptin.addEventListenerToList(o, "click", function () {
      SgCookieOptin.acceptEssentialCookies();
      SgCookieOptin.updateCookieList();
      SgCookieOptin.handleScriptActivations();
      if (!t) {
        SgCookieOptin.hideCookieOptIn();
      } else {
        SgCookieOptin.showSaveConfirmation(t);
      }
    });
    const i = e.querySelectorAll(".sg-cookie-optin-banner-button-settings");
    SgCookieOptin.addEventListenerToList(i, "click", function () {
      SgCookieOptin.hideCookieOptIn();
      SgCookieOptin.openCookieOptin(null, { hideBanner: !0 });
    });
  },
  addEventListenerToList: function (e, t, i) {
    for (let o = 0; o < e.length; ++o) {
      e[o].addEventListener(t, i, !1);
    }
  },
  hideCookieOptIn: function () {
    const t = document.querySelectorAll("#SgCookieOptin");
    for (const o in t) {
      if (!t.hasOwnProperty(o)) {
        continue;
      }
      const i = t[o],
        e = i.parentNode;
      if (!e || e.classList.contains("sg-cookie-optin-plugin")) {
        continue;
      }
      e.removeChild(i);
    }
  },
  updateCookieList: function (e) {
    const a = {};
    const l = SgCookieOptin.getCookie(SgCookieOptin.COOKIE_NAME);
    if (l) {
      const r = l.split("|");
      for (const p in r) {
        if (!r.hasOwnProperty(p)) {
          continue;
        }
        const g = r[p],
          o = g.split(":");
        if (!o.hasOwnProperty(0) || !o.hasOwnProperty(1)) {
          continue;
        }
        a[o[0]] = parseInt(o[1]);
      }
    }
    for (const c in SgCookieOptin.jsonData.cookieGroups) {
      if (!SgCookieOptin.jsonData.cookieGroups.hasOwnProperty(c)) {
        continue;
      }
      const i = SgCookieOptin.jsonData.cookieGroups[c].groupName;
      if (!i) {
        continue;
      }
      if (!a.hasOwnProperty(i)) {
        continue;
      }
      let t = document;
      /* Deaktiviert da Fehler in der Strecke
            if (!e) {
                t = e.closest(".sg-cookie-optin-box");
            }*/
      if (!t) {
        t = document;
      }
      const s = t.querySelectorAll(
        '.sg-cookie-optin-checkbox[value="' + i + '"]',
      );
      for (let n = 0; n < s.length; ++n) {
        s[n].checked = a[i] === 1;
      }
    }
  },
  openCookieDetails: function (e) {
    e.preventDefault();
    const i = e.target.parentNode;
    if (!i) {
      return;
    }
    const t = i.previousElementSibling;
    if (!t) {
      return;
    }
    if (t.classList.contains("sg-cookie-optin-visible")) {
      t.classList.remove("sg-cookie-optin-visible");
      e.target.innerHTML =
        SgCookieOptin.jsonData.textEntries.extend_box_link_text;
    } else {
      t.classList.add("sg-cookie-optin-visible");
      e.target.innerHTML =
        SgCookieOptin.jsonData.textEntries.extend_box_link_text_close;
    }
  },
  openSubList: function (e, t) {
    e.preventDefault();
    let g = 0,
      i = e.target.previousElementSibling;
    if (
      !i ||
      !i.classList.contains("sg-cookie-optin-box-cookie-detail-sublist")
    ) {
      const l = e.target.closest("#SgCookieOptin"),
        a = l.querySelectorAll(".sg-cookie-optin-box-new");
      for (const p in a) {
        if (!a.hasOwnProperty(p)) {
          continue;
        }
        let c = !0,
          o = a[p];
        if (o.classList.contains("sg-cookie-optin-visible")) {
          c = !1;
          o.classList.remove("sg-cookie-optin-visible");
          o.classList.add("sg-cookie-optin-invisible");
          e.target.innerHTML =
            SgCookieOptin.jsonData.textEntries.extend_table_link_text;
        } else {
          o.classList.remove("sg-cookie-optin-invisible");
          o.classList.add("sg-cookie-optin-visible");
          SgCookieOptin.adjustReasonHeight(l, t);
          e.target.innerHTML =
            SgCookieOptin.jsonData.textEntries.extend_table_link_text_close;
        }
        const r = o.querySelectorAll(".sg-cookie-optin-checkbox-description");
        for (const s in r) {
          if (!r.hasOwnProperty(s)) {
            continue;
          }
          const n = r[s];
          if (c) {
            n.setAttribute("data-optimal-height", n.style.height);
            n.style.height = "auto";
          } else {
            n.style.height = n.getAttribute("data-optimal-height");
          }
        }
      }
    } else {
      if (i.classList.contains("sg-cookie-optin-visible")) {
        i.classList.remove("sg-cookie-optin-visible");
        i.style.height = "";
        e.target.innerHTML =
          SgCookieOptin.jsonData.textEntries.extend_table_link_text;
      } else {
        i.classList.add("sg-cookie-optin-visible");
        i.style.height = "auto";
        g = i.getBoundingClientRect().height + "px";
        i.style.height = "";
        requestAnimationFrame(function () {
          setTimeout(function () {
            i.style.height = g;
          }, 10);
        });
        e.target.innerHTML =
          SgCookieOptin.jsonData.textEntries.extend_table_link_text_close;
      }
    }
  },
  acceptAllCookies: function () {
    let e = "";
    for (const i in SgCookieOptin.jsonData.cookieGroups) {
      if (!SgCookieOptin.jsonData.cookieGroups.hasOwnProperty(i)) {
        continue;
      }
      const t = SgCookieOptin.jsonData.cookieGroups[i].groupName;
      if (!t) {
        continue;
      }
      if (e.length > 0) {
        e += "|";
      }
      e += t + ":" + 1;
    }
    SgCookieOptin.setCookie(
      SgCookieOptin.COOKIE_NAME,
      e,
      SgCookieOptin.jsonData.settings.cookie_lifetime,
    );
    SgCookieOptin.acceptAllExternalContents();
  },
  acceptSpecificCookies: function (e) {
    let c = !1,
      i = "",
      r = null;
    if (!e) {
      r = document;
    } else {
      r = e.closest(".sg-cookie-optin-box");
    }
    const s = r.querySelectorAll(".sg-cookie-optin-checkbox:checked");
    for (const a in SgCookieOptin.jsonData.cookieGroups) {
      if (!SgCookieOptin.jsonData.cookieGroups.hasOwnProperty(a)) {
        continue;
      }
      const t = SgCookieOptin.jsonData.cookieGroups[a].groupName;
      if (!t) {
        continue;
      }
      let n = 0;
      for (let o = 0; o < s.length; ++o) {
        if (s[o].value === t) {
          n = 1;
          break;
        }
      }
      if (t === SgCookieOptin.COOKIE_GROUP_EXTERNAL_CONTENT && n === 1) {
        c = !0;
      }
      if (i.length > 0) {
        i += "|";
      }
      i += t + ":" + n;
    }
    SgCookieOptin.setCookieWrapper(i);
    if (SgCookieOptin.jsonData.settings.iframe_enabled) {
      if (c) {
        SgCookieOptin.acceptAllExternalContents();
      } else {
        SgCookieOptin.checkForExternalContents();
      }
    }
  },
  acceptEssentialCookies: function () {
    let e = "";
    for (const t in SgCookieOptin.jsonData.cookieGroups) {
      if (!SgCookieOptin.jsonData.cookieGroups.hasOwnProperty(t)) {
        continue;
      }
      const o = SgCookieOptin.jsonData.cookieGroups[t].groupName;
      if (!o) {
        continue;
      }
      let i = 0;
      if (SgCookieOptin.jsonData.cookieGroups[t].required) {
        i = 1;
      }
      if (e.length > 0) {
        e += "|";
      }
      e += o + ":" + i;
    }
    SgCookieOptin.setCookieWrapper(e);
  },
  checkForExternalContents: function () {
    if (!SgCookieOptin.jsonData.settings.iframe_enabled) {
      return;
    }
    const p = SgCookieOptin.getParameterByName("showOptIn") == !0;
    if (SgCookieOptin.jsonData.settings.activate_testing_mode && !p) {
      return;
    }
    if (!SgCookieOptin.externalContentObserver) {
      const t = document.querySelectorAll(
        SgCookieOptin.EXTERNAL_CONTENT_ELEMENT_SELECTOR,
      );
      if (t.length > 0) {
        for (const r in t) {
          if (!t.hasOwnProperty(r)) {
            continue;
          }
          SgCookieOptin.replaceExternalContentWithConsent(t[r]);
        }
      }
    }
    const n = SgCookieOptin.getCookie(SgCookieOptin.COOKIE_NAME);
    if (n) {
      const i = n.split("|");
      for (const o in i) {
        if (!i.hasOwnProperty(o)) {
          continue;
        }
        const c = i[o],
          e = c.split(":");
        if (!e.hasOwnProperty(0) || !e.hasOwnProperty(1)) {
          continue;
        }
        const a = e[0],
          s = parseInt(e[1]);
        if (a === SgCookieOptin.COOKIE_GROUP_EXTERNAL_CONTENT) {
          if (s === 1) {
            return;
          }
          break;
        }
      }
    }
    SgCookieOptin.externalContentObserver = new MutationObserver(function (
      e,
      t,
    ) {
      for (const s in e) {
        if (!e.hasOwnProperty(s)) {
          continue;
        }
        const o = e[s];
        if (o.type !== "childList" || o.addedNodes.length <= 0) {
          continue;
        }
        for (const a in o.addedNodes) {
          if (!o.addedNodes.hasOwnProperty(a)) {
            continue;
          }
          const i = o.addedNodes[a];
          if (
            typeof i.matches === "function" &&
            i.matches(SgCookieOptin.EXTERNAL_CONTENT_ELEMENT_SELECTOR)
          ) {
            SgCookieOptin.replaceExternalContentWithConsent(i);
          } else if (
            i.querySelectorAll &&
            typeof i.querySelectorAll === "function"
          ) {
            const n = i.querySelectorAll(
              SgCookieOptin.EXTERNAL_CONTENT_ELEMENT_SELECTOR,
            );
            if (n.length > 0) {
              for (const r in n) {
                if (!n.hasOwnProperty(r)) {
                  continue;
                }
                SgCookieOptin.replaceExternalContentWithConsent(n[r]);
              }
            }
          }
        }
      }
    });
    SgCookieOptin.externalContentObserver.observe(document, {
      subtree: !0,
      childList: !0,
    });
  },
  isContentWhiteListed: function (e) {
    const t = SgCookieOptin.jsonData.mustacheData.iframeWhitelist.markup
      .trim()
      .split(/\r?\n/)
      .map(function (e) {
        return new RegExp(e);
      });
    if (typeof t === "object" && t.length < 1) {
      return !1;
    }
    switch (e.tagName) {
      case "IFRAME":
        return SgCookieOptin.isElementWhitelisted(e, "src", t);
      case "OBJECT":
        return SgCookieOptin.isElementWhitelisted(e, "data", t);
      case "VIDEO":
      case "AUDIO":
        return SgCookieOptin.isAudioVideoWhitelisted(e, t);
      default:
        return !1;
    }
  },
  isElementWhitelisted: function (e, t, i) {
    if (typeof e.getAttribute !== "function") {
      return !1;
    }
    for (const o in i) {
      if (
        typeof e.getAttribute === "function" &&
        i[o].test(e.getAttribute(t))
      ) {
        return !0;
      }
    }
    return !1;
  },
  isAudioVideoWhitelisted: function (e, t) {
    if (e.hasAttribute("src")) {
      return SgCookieOptin.isElementWhitelisted(e, "src", t);
    }
    const i = e.querySelectorAll("source");
    for (const o in i) {
      if (SgCookieOptin.isElementWhitelisted(i[o], "src", t)) {
        return !0;
      }
    }
    return !1;
  },
  isElementInAllowedNode: function (e) {
    const t = document.querySelectorAll(
      SgCookieOptin.EXTERNAL_CONTENT_ALLOWED_ELEMENT_SELECTOR,
    );
    for (i in t) {
      if (typeof t[i].contains === "function" && t[i].contains(e)) {
        return !0;
      }
    }
    return !1;
  },
  replaceExternalContentWithConsent: function (e) {
    if (
      e.matches(SgCookieOptin.EXTERNAL_CONTENT_ALLOWED_ELEMENT_SELECTOR) ||
      SgCookieOptin.isElementInAllowedNode(e) ||
      SgCookieOptin.isContentWhiteListed(e)
    ) {
      return;
    }
    const i = e.parentElement;
    if (!i) {
      return;
    }
    if (
      e.tagName === "IFRAME" &&
      (!e.src || e.src.indexOf("chrome-extension") >= 0)
    ) {
      return;
    }
    let n = 0,
      s = e;
    while ((s = s.previousSibling) != null) {
      n++;
    }
    e.setAttribute("data-iframe-position-index", n);
    let o = SgCookieOptin.protectedExternalContents.length + 1;
    if (o === 0) {
      o = 1;
    }
    SgCookieOptin.protectedExternalContents[o] = e;
    const t = document.createElement("DIV");
    t.setAttribute("data-iframe-id", o);
    t.setAttribute("data-src", e.src);
    t.setAttribute("style", "height: " + e.offsetHeight + "px;");
    t.classList.add("sg-cookie-optin-iframe-consent");
    t.insertAdjacentHTML(
      "afterbegin",
      SgCookieOptin.jsonData.mustacheData.iframeReplacement.markup,
    );
    const a = t.querySelectorAll(".sg-cookie-optin-iframe-consent-accept");
    SgCookieOptin.addEventListenerToList(a, "click", function () {
      SgCookieOptin.acceptExternalContent(o);
    });
    if (e.getAttribute("data-consent-button-text")) {
      for (let r = 0; r < a.length; ++r) {
        a[r].innerText = e.getAttribute("data-consent-button-text");
      }
    }
    const p = t.querySelectorAll(".sg-cookie-optin-iframe-consent-link");
    SgCookieOptin.addEventListenerToList(
      p,
      "click",
      SgCookieOptin.openExternalContentConsent,
    );
    if (i.childNodes.length > 0) {
      i.insertBefore(t, i.childNodes[n]);
    } else {
      i.appendChild(t);
    }
    e.addEventListener("externalContentAccepted", function () {
      SgCookieOptin.acceptContainerChildNodes(e);
      return !0;
    });
    i.removeChild(e);
    const c = new CustomEvent("externalContentReplaced", {
      bubbles: !0,
      detail: { positionIndex: n, parent: i, externalContent: e },
    });
    t.dispatchEvent(c);
  },
  openExternalContentConsent: function () {
    const r = this.parentElement;
    if (!r) {
      return;
    }
    const i = r.getAttribute("data-iframe-id");
    if (!i) {
      return;
    }
    SgCookieOptin.lastOpenedExternalContentId = i;
    const n = SgCookieOptin.protectedExternalContents[i];
    if (!n) {
      return;
    }
    const e = document.createElement("DIV");
    e.id = "SgCookieOptin";
    e.insertAdjacentHTML(
      "afterbegin",
      SgCookieOptin.jsonData.mustacheData.iframe.markup,
    );
    const t = e.querySelector(".sg-cookie-optin-box-flash-message");
    if (t !== null) {
      const o = n.getAttribute("data-consent-description");
      if (o) {
        t.appendChild(document.createTextNode(o));
      } else {
        t.remove();
      }
    }
    SgCookieOptin.addExternalContentListeners(e);
    document.body.insertAdjacentElement("beforeend", e);
  },
  addExternalContentListeners: function (e) {
    const o = e.querySelectorAll(".sg-cookie-optin-box-close-button");
    SgCookieOptin.addEventListenerToList(
      o,
      "click",
      SgCookieOptin.hideCookieOptIn,
    );
    const i = e.querySelectorAll(".sg-cookie-optin-box-button-accept-all");
    SgCookieOptin.addEventListenerToList(i, "click", function () {
      SgCookieOptin.acceptAllExternalContents();
      SgCookieOptin.updateCookieList();
      SgCookieOptin.handleScriptActivations();
      SgCookieOptin.hideCookieOptIn();
    });
    const t = e.querySelectorAll(".sg-cookie-optin-box-button-accept-specific");
    SgCookieOptin.addEventListenerToList(t, "click", function () {
      SgCookieOptin.acceptExternalContent(
        SgCookieOptin.lastOpenedExternalContentId,
      );
      SgCookieOptin.updateCookieList();
      SgCookieOptin.handleScriptActivations();
      SgCookieOptin.hideCookieOptIn();
    });
  },
  acceptAllExternalContents: function () {
    if (
      SgCookieOptin.jsonData.settings.iframe_enabled &&
      SgCookieOptin.externalContentObserver
    ) {
      SgCookieOptin.externalContentObserver.disconnect();
    }
    for (let i in SgCookieOptin.protectedExternalContents) {
      i = parseInt(i);
      if (!document.querySelector('div[data-iframe-id="' + i + '"]')) {
        continue;
      }
      SgCookieOptin.acceptExternalContent(i);
    }
    const c = SgCookieOptin.getCookie(SgCookieOptin.COOKIE_NAME);
    if (!c) {
      SgCookieOptin.acceptAllCookies();
      SgCookieOptin.hideCookieOptIn();
      return;
    }
    let s = !1,
      e = "",
      o = c.split("|");
    for (const a in o) {
      if (!o.hasOwnProperty(a)) {
        continue;
      }
      const p = o[a],
        t = p.split(":");
      if (!t.hasOwnProperty(0) || !t.hasOwnProperty(1)) {
        continue;
      }
      let n = t[0],
        r = parseInt(t[1]);
      if (n === SgCookieOptin.COOKIE_GROUP_EXTERNAL_CONTENT) {
        s = !0;
        r = 1;
      }
      if (e.length > 0) {
        e += "|";
      }
      e += n + ":" + r;
    }
    if (!s) {
      e += "|" + SgCookieOptin.COOKIE_GROUP_EXTERNAL_CONTENT + ":" + 1;
    }
    SgCookieOptin.setCookieWrapper(e);
  },
  acceptExternalContent: function (e) {
    if (!e) {
      e = parent.getAttribute("data-iframe-id");
      if (!e) {
        return;
      }
    }
    const o = document.querySelector('div[data-iframe-id="' + e + '"]'),
      t = SgCookieOptin.protectedExternalContents[e];
    if (!t || !o) {
      return;
    }
    t.setAttribute("data-iframe-allow-always", 1);
    const n = t.getAttribute("data-iframe-position-index");
    t.removeAttribute("data-iframe-position-index");
    const i = o.parentNode;
    i.removeChild(o);
    if (i.childNodes.length > 0) {
      i.insertBefore(t, i.childNodes[n]);
    } else {
      i.appendChild(t);
    }
    const r = new CustomEvent("externalContentAccepted", {
      bubbles: !0,
      detail: { positionIndex: n, parent: parent, externalContent: t },
    });
    t.dispatchEvent(r);
  },
  acceptContainerChildNodes: function (e) {
    const t = e.querySelectorAll("[data-iframe-id]");
    if (t.length > 0) {
      for (const n in t) {
        const o = t[n];
        if (typeof o.getAttribute !== "function") {
          continue;
        }
        const i = o.getAttribute("data-iframe-id");
        if (!i) {
          continue;
        }
        SgCookieOptin.acceptExternalContent(i);
      }
    }
  },
  getCookie: function (e) {
    const t = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
    return t ? t[2] : null;
  },
  setCookie: function (e, t, i) {
    const n = new Date();
    n.setTime(n.getTime() + 24 * 60 * 60 * 1000 * i);
    let o = e + "=" + t + ";path=/";
    if (SgCookieOptin.jsonData.settings.set_cookie_for_domain.length > 0) {
      o += ";domain=" + SgCookieOptin.jsonData.settings.set_cookie_for_domain;
    }
    o += ";expires=" + n.toGMTString();
    o += ";Secure;SameSite=None";
    document.cookie = o;
  },
  setSessionCookie: function (e, t) {
    let i = e + "=" + t + "; path=/";
    if (SgCookieOptin.jsonData.settings.set_cookie_for_domain.length > 0) {
      i += ";domain=" + SgCookieOptin.jsonData.settings.set_cookie_for_domain;
    }
    i += ";Secure;SameSite=None";
    document.cookie = i;
  },
  setCookieWrapper: function (e) {
    let a = !1;
    if (SgCookieOptin.jsonData.settings.session_only_essential_cookies) {
      let i = !1,
        r = !1,
        o = e.split("|");
      for (const n in o) {
        if (!o.hasOwnProperty(n)) {
          continue;
        }
        const t = o[n];
        if (
          t.indexOf(SgCookieOptin.COOKIE_GROUP_ESSENTIAL) === 0 ||
          t.indexOf(SgCookieOptin.COOKIE_GROUP_IFRAME) === 0
        ) {
          continue;
        }
        i = !0;
        if (t.indexOf(":1") > 0) {
          r = !0;
          break;
        }
      }
      a = i && !(i && r);
    }
    if (a) {
      SgCookieOptin.setSessionCookie(SgCookieOptin.COOKIE_NAME, e);
    } else {
      SgCookieOptin.setCookie(
        SgCookieOptin.COOKIE_NAME,
        e,
        SgCookieOptin.jsonData.settings.cookie_lifetime,
      );
    }
  },
  showSaveConfirmation: function (e) {
    const i = e.firstChild;
    if (!i.classList.contains("sg-cookie-optin-save-confirmation")) {
      const t = document.createElement("DIV");
      t.classList.add("sg-cookie-optin-save-confirmation");
      t.insertAdjacentText(
        "afterbegin",
        SgCookieOptin.jsonData.textEntries.save_confirmation_text,
      );
      e.insertBefore(t, e.firstChild);
    }
  },
  getParameterByName: function (e, t) {
    if (!t) {
      t = window.location.href;
    }
    e = e.replace(/[\[\]]/g, "\\$&");
    const o = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)"),
      i = o.exec(t);
    if (!i) {
      return null;
    }
    if (!i[2]) {
      return "";
    }
    return decodeURIComponent(i[2].replace(/\+/g, " "));
  },
  findProtectedElementsBySelector: function (e) {
    const i = [];
    for (const t in SgCookieOptin.protectedExternalContents) {
      if (
        typeof SgCookieOptin.protectedExternalContents[t].matches ===
          "function" &&
        SgCookieOptin.protectedExternalContents[t].matches(e)
      ) {
        i.push(SgCookieOptin.protectedExternalContents[t]);
      }
    }
    return i;
  },
  addAcceptHandlerToProtectedElements: function (e, t) {
    if (!t) {
      t = "*";
    }
    const i = SgCookieOptin.findProtectedElementsBySelector(t);
    this.addEventListenerToList(i, "externalContentAccepted", e);
  },
  closestPolyfill: function () {
    const ElementPrototype = window.Element.prototype;
    if (typeof ElementPrototype.matches !== "function") {
      ElementPrototype.matches =
        ElementPrototype.msMatchesSelector ||
        ElementPrototype.mozMatchesSelector ||
        ElementPrototype.webkitMatchesSelector ||
        function (e) {
          let element = this;
          const elements = (
            element.document || element.ownerDocument
          ).querySelectorAll(e);
          let index = 0;
          while (elements[index] && elements[index] !== element) {
            ++index;
          }
          return Boolean(elements[index]);
        };
    }
    if (typeof ElementPrototype.closest !== "function") {
      ElementPrototype.closest = function (e) {
        let element = this;
        while (element && element.nodeType === 1) {
          if (element.matches(e)) {
            return element;
          }
          element = element.parentNode;
        }
        return null;
      };
    }
  },
};
SgCookieOptin.run();
/* ENDE Code aus cookieOptin.js */
